import i18n from '@/i18n';
import fetchData, { fetchPure } from '@/api/fetch';
import tojs from 'await-to-js';
import $store from '@/store';
import { message as $vhMessage } from '@/tools/reset-message.js';
import { sessionOrLocal } from '@/tools/utils.js';
import { emitter, EMIT_DEFINE } from '@/tools/emitter.js';
import { isEmbed } from '@/tools/utils';
import log from 'loglevel';
/**
 * 初始化回放信息
 * @param {*} id 回放id（标品用record_id, 嵌入页用vod_id）
 */
export async function initRecordInfo(id) {
  const promiseFetchData = isEmbed()
    ? fetchData('vodInfo', {
        vod_id: id
      })
    : fetchData('recordInfo', {
        record_id: id
      });
  const [err, result] = await tojs(promiseFetchData);
  if (err || !result || result.code != 200) {
    $vhMessage.error(err?.msg || result?.msg || `${i18n.t('ai.k_005001')}`);
    return false;
  }
  if (result.data.transcode_status != 1) {
    $vhMessage.warning(`${i18n.t('ai.k_005002')}`);
    return false;
  }
  if (isEmbed()) {
    const name = sessionOrLocal.get(`video_name_${id}`);
    if (name) {
      result.data.name = name;
    }
  }
  $store.commit('video/setRecordInfo', result.data);
}

/**
 * 智能解析-信息查询
 * @param {Number} revoId (record_id 或者 vod_id)
 */
export async function getRecordAsr(revoId) {
  const params = {
    [isEmbed() ? 'vod_id' : 'record_id']: revoId
  };
  let [err, result] = await tojs(fetchData('getRecordAsr', params));
  if (err || !result || result.code !== 200) {
    if (err?.code === 600001) {
      // 不存在
      result = {
        data: {
          status: 0
        }
      };
    } else {
      $vhMessage.error(`${i18n.t('ai.k_005003')}`);
      return;
    }
  }
  doParsingAsrResult(result.data);
}

/**
 *  解析结果处理
 * @param {*} data 解析结果数据
 * @param {*} fromMsg 是否通过消息通知来处理的
 */
export async function doParsingAsrResult(data, fromMsg) {
  log.info('doParsingAsrResult:', JSON.stringify(data));
  // status 状态，0:不存在，1:成功，2:失败，3:进行中 4:重新校验 10: 校验完成
  $store.commit('video/setAsrStatus', data.status);
  if ([1, 4, 10].includes(data.status)) {
    if (data.status === 1) {
      // 解析成功，清除上次操作的缓存
      clearAsrCache();
    }
    if (data.lang) {
      // 设置解析语言
      $store.commit('video/setAsrLang', data.lang);
    }
    if (fromMsg) {
      emitter.emit(EMIT_DEFINE.videoAsrTextUpdate);
    }

    // result.data.file_url asr结果文件链接地址，一个json文件
    const rest = await fetchPure(data.file_url).then(res => res.json());
    if (rest) {
      let g = 0; // 分组
      let count = 0; // 每段文字长度
      const limit = 180; //分段限制
      for (const item of rest.content) {
        count = count + item.text.length;
        item.g = `g${(g + '').padStart(3, '0')}`;
        if (count >= limit) {
          item.wrap = true;
          count = 0;
          g++;
        }
      }
      $store.commit('video/setAsrData', rest);
    }
  }
}

// 清除解析结果编辑缓存
export async function clearAsrCache() {
  const recordId = $store.state.video.recordInfo?.id;
  if (recordId) {
    sessionOrLocal.removeItem(`asr-${recordId}`);
    sessionOrLocal.removeItem(`asr-his-${recordId}`);
    sessionOrLocal.removeItem(`asr-hisidx-${recordId}`);
  }
}

// 获取paas回放信息
export async function getPlayBackInfo(vodId) {
  log.info('getPlayBackInfo $store.state.video.recordInfo', $store.state.video.recordInfo);
  log.info('getPlayBackInfo $store.state.video.playBackInfo:', $store.state.video.playBackInfo);
  if (!isEmbed() && !$store.state.video.recordInfo) return;
  if (!$store.state.video.playBackInfo) {
    let promiseFetchData;
    if (isEmbed()) {
      promiseFetchData = fetchData('playBackInfo');
    } else {
      promiseFetchData = fetchData('playBackPreview', {
        webinar_id: $store.state.video.recordInfo.webinar_id,
        record_id: $store.state.video.recordInfo.id,
        type: 0
      });
    }
    const [err, result] = await tojs(promiseFetchData);
    if (err || !result || result.code != 200) {
      this.$vhMessage.error(err?.msg || result?.msg || `${i18n.t('ai.k_005004')}`);
      return;
    }
    if (isEmbed()) {
      result.data.paasAppId = result.data.app_id;
      result.data.paasAccessToken = result.data.access_token;
      result.data.player = {
        paasRecordId: $store.state.video.recordInfo?.vod_id || vodId
      };
    }
    $store.commit('video/setPlayBackInfo', result.data);
    log.info('getPlayBackInfo 处理后data:', result.data);
  }
}
export function validAsrStatus() {
  if ($store.state.video.asrStatus === 3) {
    $vhMessage.error(`${i18n.t('ai.k_005005')}`);
    return false;
  } else if ($store.state.video.asrStatus === 0) {
    $vhMessage.error(`${i18n.t('ai.k_005006')}`);
    return false;
  }
  return true;
}
